import * as types from './types'
export default {
  [types.SET_STEP](state, data) {
    state.step = data
  },
  [types.SET_DELIMITER](state, data) {
    state.delimiter = data
  },
  [types.SET_MAPPING_ID](state, data) {
    state.mappingId = data
  },
  [types.SET_SCHEMA_NAME](state, data) {
    state.schemaName = data
  },
  [types.SET_MAPPED_DATA](state, data) {
    state.mappedData = data
  },
  [types.SET_ROWS_TO_SKIP](state, data) {
    state.rowsToSkip = data
  },
  [types.SET_CORPORATE_ID](state, data) {
    state.corporateId = data
  },
  [types.SET_TEMPLATE_NAME](state, data) {
    state.templateName = data
  },
  [types.RESET_VISITED_STEP](state, data) {
    state.visitedStep = data
  },
  [types.SET_IS_SKIP_CHECKED](state, data) {
    state.isSkipChecked = data
  },
  [types.SET_FILE_DATA_ARRAY](state, data) {
    state.fileDataArray = data
  },
  [types.SET_CSVDATA](state, data) {
    state.csvData = data
  },
  // [types.SET_ADDRESS_ERROR](state, data) {
  //   state.addressError = data
  // },
  // [types.SET_ADDRESS_APPROVED](state, data) {
  //   state.addressApproved = data
  // },
  // [types.SET_ADDRESS_DUPLICATE](state, data) {
  //   state.addressDuplicate = data
  // },
  [types.SET_SCHEMAS](state, data) {
    state.schemas = data.map(d => {
      return { name: d.SchemaName, value: d.SchemaName }
    })
  },
  [types.SET_TEMPLATES](state, data) {
    state.templates = data.map(d => {
      return { name: d.TemplateName, value: d.TemplateName }
    })
  },
  [types.SET_SCHEMA_COLUMNS](state, data) {
    state.schemaColumns = data.map(d => {
      return { name: d.DisplayName, value: d.ColumnName }
    })
  },
  [types.SET_VISITED_STEP](state, currentStep) {
    state.visitedStep = currentStep > state.visitedStep
      ? currentStep
      : state.visitedStep
  },
  [types.SET_MAPPING](state, data) {
    data = data[0]
    state.mappingId = data.DataSchemaTemplate
    state.delimiter = data.Delimiter
    state.mappedData = data.MappedData
    state.rowsToSkip = data.RowsToSkip
    state.schemaName = data.SchemaName
    state.templateName = data.TemplateName
    state.isSelectedData = data.IsSelectedData
    state.isSkipChecked = data.IsSkipChecked
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/import-data/mutations.js